import React from 'react';
import './App.css';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Gewerke } from './components/Gewerke';
import { Services } from './components/Services';
import { About } from './components/About';
import { Projects } from './components/Projects';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { JobBanner } from './components/JobBanner';
import { Impressum } from './components/Impressum';
import { Datenschutz } from './components/Datenschutz';
import { AGB } from './components/AGB';
import { TeamPage } from './components/TeamPage';
import { ProjectsPage } from './components/ProjectsPage';
import { WhatsAppButton } from './components/WhatsAppButton';
import { Toaster } from './components/ui/sonner';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Gewerke />
        <Services />
        <About />
        <Projects />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <JobBanner />
      <Toaster />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/projekte" element={<ProjectsPage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
        </Routes>
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;